export default "__VITE_ASSET__CqjNNV0E__"